import React, { Component } from 'react';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { injectScript, removeScript } from 'srcReact/helpers/utils';
import { isEmpty } from 'srcReact/helpers/validator';

class GooglePlacesAutocompleteExtended extends Component {

    constructor(props) {
        super(props)

        // this.state = {
        //     language: this.props.language?this.props.language:"en",
        //     timeoutId: null,
        //     ready:false,
        //     scriptId: "google-autocomplete-script",
        //     scriptUrl: 'https://maps.googleapis.com/maps/api/js?libraries=places'
        // }
    }

    componentDidMount() {
        // const { googleApiKey } = this.props
        // const { language, scriptId, scriptUrl } = this.state

        // if (!isEmpty(googleApiKey)) {
        //     injectScript(scriptId, scriptUrl+'&language='+language+'&key='+googleApiKey)
        // }
        //
        // this.initalizeService()
    }

    componentWillUnmount() {
        // removeScript(this.state.scriptId)
    }

    initalizeService = () => {
        if (!window.google) {
            const timeoutId = setTimeout(this.initalizeService, 500)
            this.setState({ timeoutId })
            return
        }

        if (!window.google.maps) {
            const timeoutId = setTimeout(this.initalizeService, 500)
            this.setState({ timeoutId })
            return
        }

        if (!window.google.maps.places) {
            const timeoutId = setTimeout(this.initalizeService, 500)
            this.setState({ timeoutId })
            return
        }

        this.setState({
            timeoutId: null,
            ready: true
        });
    }


    render () {
        return (
            <React.Fragment>
                <GooglePlacesAutocomplete {...this.props} />
            </React.Fragment>
        )
    }
}

export { GooglePlacesAutocompleteExtended }
